import { ThemeUIStyleObject } from "theme-ui";

export const smallFlexStyling: ThemeUIStyleObject = {
  borderTop: "solid 1px",
  borderTopColor: "gray",
  flexWrap: "wrap",
  textTransform: "uppercase",
  "&:last-child": {
    borderBottom: "solid 1px",
    borderBottomColor: "gray",
  },
};

export const textStyles: ThemeUIStyleObject = {
  fontSize: ["paragraphSmall", "paragraphMedium"],
  fontFamily: "NyCarlsbergDisplay-Regular",
  textTransform: "uppercase",
  lineHeight: 1.5,
  paddingBlock: 3,
  margin: 0,
  letterSpacing: "2px",
  span: {
    fontFamily: "NyCarlsbergDisplay-Light",
    textTransform: "none",
  },
  "&:last-child": {
    borderTop: ["solid 1px", "solid 1px", "none"],
    borderTopColor: ["gray", "gray", "none"],
  },
};

export const width30: ThemeUIStyleObject = {
  width: ["100%", "100%", "30%"],
};

export const width70: ThemeUIStyleObject = {
  width: ["100%", "100%", "70%"],
};

export const width50: ThemeUIStyleObject = {
  width: ["100%", "100%", "50%"],
};

export const brandStyles: ThemeUIStyleObject = {
  textTransform: "uppercase",
  fontSize: "paragraphMedium",
  fontWeight: "regular",
  fontFamily: "NyCarlsbergDisplay-Regular",
  color: "darkGreen",
  letterSpacing: "2px",
};

export const breweryStyles: ThemeUIStyleObject = {
  color: "darkGreen",
  fontSize: ["paragraphMedium", "paragraphMedium", "h3"],
};

export const beerNameStyles: ThemeUIStyleObject = {
  color: "darkGreen",
  letterSpacing: "1px",
  fontSize: ["h2", "h2", "headingFlavour"],
  marginLeft: "-3px",
};

export const textContainerStyles: ThemeUIStyleObject = {
  height: "100%",
  display: "flex",
  flexDirection: "column",
  paddingLeft: [5, 6, "10px"],
  paddingTop: [5, 6, 16],
  paddingRight: [5, 6, "210px"],
  paddingBottom: [5, 6, 8],
};

export const resetPrevNextButton: ThemeUIStyleObject = {
  background: "none",
  outline: "none",
  width: "auto",
  height: "auto",
  marginTop: 0,
  borderRadius: "50%",
  border: "none",
  position: "relative",
  transition: "all 0.2s linear",
  "> div": {
    position: [null, null, "relative"],
  },
  "svg circle": {
    fill: "white",
    opacity: 1,
    transition: "all 0.2s linear",
  },
  "> div > div": {
    marginLeft: 0,
    transition: "all 0.2s linear",
  },
  "svg path": {
    fill: "darkGreen",
    opacity: 1,
  },
  "&:hover, &:focus": {
    boxShadow: "none",
    "svg circle": {
      fill: "#d0d1d2",
    },
    "> div > div": {
      marginLeft: "0.4rem",
    },

    "> .button-prev": {
      boxShadow: "none",
      "svg circle": {
        fill: "mediumGray",
        opacity: 0.3,
      },
      "> div": {
        marginLeft: "-0.4rem",
      },
    },
  },
};

export const buttonStyles = (
  disabled: boolean | undefined
): ThemeUIStyleObject => ({
  opacity: disabled ? 0.2 : 1,
  background: "transparent",
  border: "none",
  display: "flex",
  alignItems: "center",
  color: "rgb(40, 74, 65)",
  fontFamily: "NyCarlsbergDisplay-Regular",
  fontSize: ["smText", "paragraphMedium"],
  textTransform: "uppercase",
  cursor: "pointer",
  gap: "10px",
  ":focus, :active": {
    outline: "none",
    boxShadow: "none",
  },
  ...resetPrevNextButton,
});

const arrowBaseStyles: ThemeUIStyleObject = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate3d(-50%, -50%, 0)",
  height: "16px",
};

export const leftArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};
export const rightArrowSpanStyles: ThemeUIStyleObject = {
  ...arrowBaseStyles,
};

export const buttonLeftStyle: ThemeUIStyleObject = {
  mr: 1,
};
export const buttonRightStyle: ThemeUIStyleObject = {
  ml: 1,
};
